module.exports = __webpack_public_path__ + "img/Review3.f1fc5a88.png";